import React, { PureComponent, Fragment } from 'react'
import styles from './Card.scss'
import classNames from 'classnames'

export interface IProps {
    className: String,
    children: React.ReactNode,
    onClick: (any) => void,
    onMouseMove: () => boolean,
    onMouseEnter: () => boolean,
    onMouseLeave: () => boolean,
}

class Card extends PureComponent<IProps, any> {

    constructor(props) {
        super(props)

        this.state = {
            isActive: false,
        }

        this.onMouseMove = this.onMouseMove.bind(this)
        this.onMouseEnter = this.onMouseEnter.bind(this)
        this.onMouseLeave = this.onMouseLeave.bind(this)
    }

    onMouseMove() {
        if (this.props.onMouseMove())
            this.focus()
    }

    onMouseEnter() {
        if (this.props.onMouseEnter())
            this.focus()
    }

    onMouseLeave() {
        if (this.props.onMouseLeave())
            this.blur()
    }

    focus() {
        this.setState({ ...this.state, isActive: true })
    }

    blur() {
        this.setState({ ...this.state, isActive: false })
    }

    render() {
        return (
            <div
                onMouseDown={(e) => this.props.onClick(e)}
                onMouseMove={this.onMouseMove}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                className={classNames(styles.wrapper, this.props.className, { [styles.active]: this.state.isActive })}>
                {this.props.children}
            </div>
        )
    }
}

Card.defaultProps = {
    onClick: (e) => null,
    onMouseMove: () => true,
    onMouseEnter: () => true,
    onMouseLeave: () => true,
}

export default Card